module.exports = __webpack_public_path__ + "img/serrote e tesoura poda e alcool para desisfestação.a37e9802.webp";